import { isTestEnv, oneDayInMs } from 'config';
import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      cacheTime: 7 * oneDayInMs, // 7 day
    },
    mutations: { retry: isTestEnv ? 0 : 3 },
  },
});
